export const name = 'cocoen';
export const componentName = `${name}-component`;

export type Orientation = 'horizontal' | 'vertical';
